module.exports = __webpack_public_path__ + "static/media/tutorial_top_image@2x.a1e55c1d.png";